import { useInView } from '@/hooks/useInView';

const cartoons = [
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/06/image-306.jpg', title: 'Lights and Traffic', desc: "We'll create a traffic light and save the city from traffic jams" },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/06/image-303.jpg', title: 'Light Energy', desc: 'We will help the dragon Sali to learn what energy is' },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/06/image-304.jpg', title: 'Global Warming', desc: "We'll figure out why it's colder in the mountains than in the valley" },
  { img: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/06/image-305.jpg', title: 'Palette of Melodies', desc: "We'll learn the notes and colors of the rainbow in English" },
];

export default function CartoonSection() {
  const { ref, inView } = useInView();

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="bg-gray-50 py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className={`text-center mb-12 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-yellow-500 mb-3">Content</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 font-syne">Examples of our educational cartoons</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cartoons.map((c, i) => (
            <div
              key={c.title}
              className={`bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-yellow-300 hover:-translate-y-1 transition-all duration-300 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="w-full h-44 overflow-hidden">
                <img src={c.img} alt={c.title} className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <h4 className="text-sm font-bold text-gray-900 mb-2 uppercase tracking-wide">{c.title}</h4>
                <p className="text-xs text-gray-500 leading-relaxed">{c.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
